/* eslint-disable jsx-a11y/no-onchange */
/** @jsx jsx */
import { array, shape } from 'prop-types'
import { jsx, Flex, Text } from 'theme-ui'
import { useField } from 'formik'
import './formInputs.css'
import { ErrorMessage } from './Common'
import { SelectField } from '.'

const SelectFieldRange = ({ question, selectedValues, ...props }) => {
  const [field, meta, helpers] = useField({ ...props, name: question.id })

  const { setValue } = helpers

  const groupedAnswers = [[], []]
  question.answers.forEach(answer =>
    groupedAnswers[answer.groupId - 1].push(answer)
  )

  const onSelectChange = e => {
    const newAnswers =
      selectedValues && selectedValues.length > 0 ? selectedValues : ['', '']
    const answerId = e.target.value
    const groupIndex = groupedAnswers.findIndex(answerGroup =>
      answerGroup.some(answer => answer.id === answerId)
    )
    newAnswers[groupIndex] = answerId
    setValue(newAnswers)
  }

  return (
    <Flex
      sx={{
        mt: -32,
        alignItems: 'center',
        width: '80%',
      }}
    >
      {groupedAnswers.map((answerGroup, groupIndex) => (
        <Flex key={groupIndex} sx={{ alignItems: 'center' }}>
          <SelectField
            {...field}
            {...props}
            id={`${question.id}-${answerGroup[groupIndex].groupId}`}
            label={question.id}
            name={question.id}
            hideLabel
            placeholder={answerGroup[groupIndex].placeholder}
            onChange={e => onSelectChange(e)}
            value={selectedValues ? selectedValues[groupIndex] : ''}
          >
            {answerGroup.map((answer, i) => (
              <option key={answer.id} value={i > 0 ? answer.id : ''}>
                {i > 0 ? answer.text : answer.placeHolder}
              </option>
            ))}
          </SelectField>
          {groupIndex === 0 && <Text sx={{ mx: 5, mt: 2 }}>-</Text>}
        </Flex>
      ))}
      {meta.touched && meta.error ? (
        <ErrorMessage>{meta.error}</ErrorMessage>
      ) : null}
    </Flex>
  )
}

SelectFieldRange.propTypes = {
  question: shape({
    answers: array,
  }).isRequired,
  selectedValues: array,
}

export default SelectFieldRange
